module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    API_URL: "https://sswdashboard-prod-cus-api.azurewebsites.net/api/",

        // http://localhost:4398/API/
  }
};